import React, { useState, useEffect } from "react";
import { Mensaje } from "../Message/message";
import { GridComponent, ColumnsDirective, ColumnDirective, Filter, Page, Sort, Resize, Inject,  } from '@syncfusion/ej2-react-grids';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css'; 
import "./calcular_almacenaje.css";
import { URL_CALC, URL_CONSULTAR_SUCURSALES, URL_CONSULTAR_BALANCE, USER, SEND_CALC, PSW, URL_LOGIN_SUCURSALES, GENERATE_TARIFA,SEARCH_COMPANY,GETREPORT } from "../paths";
import { fetchData } from "../../hooks/fetch/const_fetch";
import DatalistInput from 'react-datalist-input';
import 'react-datalist-input/dist/styles.css';
import Modal from "../modal";

import { useModal } from '../../hooks/useModal';
import { getUserName,getUserBillingIdentifier,getUserFiscalIdentifier, getUserID, getIntUserEntityTypeId,getintUserEntityId,getUserEntityName, getUserEntityIsEmployee } from "../datainfo/dto";

import Icono from "../iconos/iconos";

import { downloadPdf } from "../downloadPdf";

const Detalle_Calcular_Almacenaje=({contenedor,validalibrehasta,calcsumarys,GetCalcSumarys, plazodiaslibres, fechaalmacenaje, setSobreDimension,setEsImo,setLibreHasta,decNetweight,setValidaReferencia,setValidaContenedor,setValidaBl, setStrBl, setContenedor,  intIsAttached, intIsFull, librehasta, Limpiar_Campos, tipostraficos, intTraffic,setIntTraffic, tipoarchivo, setTipoArchivo, moneda,setMoneda,calcularhasta, strbl, validiamoneda,setValidaMoneda, setCalcularHasta, validacalcularhasta,setValidaCalcularHasta, setIsLoading, strreferencia, setStrReferencia, lngUniversalId, buqueviaje, esimo, sobredimension}) => {

    const [isEmployee,setIsEmployee] = useState(getUserEntityIsEmployee()); 
    const [regfc,setRegFC] = useState(""); 
    const [requiredrfc,setRequiredrFC] = useState(""); 
    const [sucursalid,setSucursalId]   = useState("");
    const [validasucursal,setValidaSucursal] = useState("");
       
    const [folio,setFolio] = useState(""); 
    const [estado,setEstado] = useState("");

    const [dtodias_almacenaje,setDtoDiasAlmacenaje] = useState([]); 
    const [dtosucursales,setDtoSucursales] = useState([]); 
    
    const [diasalamcenaje,setDiasAlmacenaje] = useState("0.0");
    const [subtotal,setSubTotal] = useState("0.0");
    const [calathuStorageFeeId,setCalathuStorageFeeId] = useState(0);
    const [iva,setIva] = useState("0.0");
    const [total,setTotal] = useState("0.0");

    
    const [hasExcedCredit,setHasExcedCredit] = useState(false);
    /****************************************************************************/
        const [listaentidades, setListaEntidades] = useState();
        const [listaagencias, setListaAgencias] = useState();

        const [entidadid,setEntidadId] = useState(0);
        const [nombreentidad,setNombreEntidad] = useState("");
        const [validaentidad,setValidaEntidad] = useState("");
        const [readOnlyentidad,setReadOnlyEntidad] = useState(false);

        const [requiredid,setRequiredId] = useState(0);
        const [nombrerequired,setNombreRequired] = useState("");
        const [validarequired,setValidaRequired] = useState("");
        const [readOnlyrequired,setReadOnlyRequired] = useState(false);

        const [intBillId,setIntBillId] = useState("");
        const [intRequiredBillId,setIntRequiredBillId] = useState("");

        const [intInvoiceCalathusId,setIntInvoiceCalathusId] = useState(0);
        const [intInvoiceType, setIntInvoiceType] = useState(0);

        const [intRequiredbyId,setIntRequiredbyId] = useState(0);
        const [intRequiredType, setIntRequiredType] = useState(0);
  
        const [mensaje_saldo,setMensajeSaldo] = useState("");
    /****************************************************************************/
    let [esrechazarcalculo,setEsRechazarCalculo] = useState(false);
    
    const [isOpenModalRechazarCalculo, OpenModalRechazarCalculo, closeModalRechazarCalculo] = useModal(false);
    let [modo_cap_doc,setModoCapDoc] = useState(0);//1. Archivos de expediente // 2. Archivos de rechazo // 3. Comprobantes de pago
    
    const [comment,setMotivoRechazo] = useState("");
    const [validacomment,setValidaMotivoRechazo] = useState("");
 
    const [validatipoarchivo,setValidaTipoArchivo] = useState("");
    const [validabuqueviaje,setValidaBuqueViaje] = useState("");
    
    const [validatIntTraffic,setValidaIntTraffic] = useState("");
    
    /************************************************************************************************/
 
    const [strServiceDate, setStrServiceDate]=useState();  
    /************************************************************************************************/
   
    //FILE***********************************************************************************/
    const [validaarchivo,setValidaArchivo] = useState("");
    const [msgfile,setMsgFile] = useState("");
    const [filepdf,setFilePDF] = useState(""); 
    const [pdfData, setPdfData] = useState("");
    const [pdfname, setPdfName] = useState("");
    const [pdfformat, setPdfFormat] = useState("");
    const [pdfsize, setPdfSize] = useState("");
    /****************************************************************************************/
    
    const [blnHasCredit, setBlnHasCredit]=useState(true); //TRUE/FALSE, si Agente tiene Credito
    const [decCreditLimit, setDecCreditLimit]=useState(0); // Limite de crédito de la Agencia
    
 
    const [files, setFiles]=useState([]);
    const [detail, setDetail]=useState([]); 
    const [validanombrearchivo,setValidaNombreArchivo] = useState("");
 
    
    const [balance,setBalance] = useState("");

    const handleFileChanges = (event) => {
        try{
                setPdfData("");
                setPdfSize("");
                setMsgFile("");
                setPdfName("");
                setValidaArchivo("");

                if(event.target.files[0].type === "" || event.target.files[0].type === undefined ){
                    Mensaje( "El Formato del archivo debe ser PDF y pesar máximo 5MB." ,"warning","top-center",5000);    
                    setMsgFile("El Formato del archivo debe ser PDF y pesar máximo 5MB.");
                    return;
                }  

                if(event.target.files[0].type !== "application/pdf" && event.target.files[0].type !== "image/jpeg"){ 
                    setValidaArchivo("is-invalid"); 
                    setMsgFile("El Formato del archivo debe ser PDF o JPEG.");//+event.target.files[0].type);
                    setPdfName("")
                    setValidaNombreArchivo(" is-invalid ")
                    event.target.value = null;
                    return;
                }
        
                //alert("Tamaño:"+(event.target.files[0].size/1024)/1024)
                if( ((event.target.files[0].size/1024)/1024) > 5){ 
                    setValidaArchivo("is-invalid");
                    setMsgFile("El tamaño del archivo debe tener maximo 5 MB.")//no es valido, tamaño: "+event.target.files[0].size);
                    event.target.value = null;
                    return;
                }
       
                setValidaArchivo("is-valid");
                setPdfFormat(event.target.files[0].type);
                setPdfSize(event.target.files[0].size);
                setPdfName(event.target.files[0].name); 
                const file = event.target.files[0];
                const text =  file.name;  
                const myArray = text.split("."); 
                setPdfName(myArray[0]); 
                if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const pdfBytes = btoa(new Uint8Array(e.target.result).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                    setPdfData(pdfBytes); 
                };
                reader.readAsArrayBuffer(file);
                }
        }catch(err){
            setPdfData([]);
            setValidaArchivo(" is-invalid ");
        } 
    };
  
    /***  PRE-CALCULO ***/
    const Generar_Tarifa=async(mostrar_cortinilla=true)=>{
        try{ 
            let valida = true;
 
            if(buqueviaje.trim().length > 3 ){
                setValidaBuqueViaje(" is-valid ");
            }else{
                setValidaBuqueViaje(" is-invalid ");
                valida = false;
            }

            if(moneda > 0 && moneda < 3 ){
                setValidaMoneda(" is-valid ");
            }else{
                setValidaMoneda(" is-invalid ");
                valida = false;
            }

            if(validaentidad===" is-valid " && entidadid > 0 && intInvoiceCalathusId > 0  && intInvoiceType > 0){
                setValidaEntidad(" is-valid ");
            }else{
                setValidaEntidad(" is-invalid ");
                valida = false;
            }
            
            if(isEmployee){
                // console.log('validarequired: ',validarequired, 'requiredid: ',requiredid , 'intRequiredType: ',intRequiredType)
                if(validarequired===" is-valid " && requiredid > 0 && intRequiredbyId > 0  && intRequiredType > 0){
                    setValidaRequired(" is-valid ");
                }else{
                    alert('ES INVALIDO')
                    setValidaRequired(" is-invalid ");
                    valida = false;
                }
            }
            
            if(sucursalid > 0 ){
                setValidaSucursal(" is-valid ");
            }else{
                setValidaSucursal(" is-invalid ");
                valida = false;
            }

            if(intTraffic > 0  ){
                setValidaIntTraffic(" is-valid ");
            }else{
                setValidaIntTraffic(" is-invalid ");
                valida = false;
            }

            if( calcularhasta !== ""  ){
                setValidaCalcularHasta(" is-valid ");
            }else{
                setValidaCalcularHasta(" is-invalid ");
                valida = false;
            }
            
            if(!valida){
                return;
            } 
            
            if(mostrar_cortinilla){
                setIsLoading(true); 
            } 
            setEstado("");
            setFolio("")
            setDetail([]);
                const url = URL_CALC+GENERATE_TARIFA;  
                const params = {
                    "lngUniversalId":lngUniversalId,
                    "strRFCInvoice":regfc,   
                    "intBillIdInvoice":intBillId,
                    "strRFCRequired": isEmployee ? requiredrfc : getUserFiscalIdentifier(),   
                    "intBillIdRequired": isEmployee ? intRequiredBillId : getUserBillingIdentifier(),
                    "intTraffic":intTraffic,
                    "decNetweight":decNetweight,
                    "intIsIMO":esimo,
                    "intIsOverDim":sobredimension,
                    "intIsAttached":intIsAttached, // asunto
                    "intIsFull":intIsFull, // si es 1-lleno o 0-vacio
                    "strLimitDate":calcularhasta,//librehasta,
                    "strusername":getUserName(),
                    "intCurrency":moneda,

                    "intRequiredCalathusId" : isEmployee ? requiredid : getintUserEntityId(),  //intUserEntityId
                    "intRequiredType" : isEmployee ? intRequiredType : getIntUserEntityTypeId(),       //intUserEntityTypeId
                    
                    "intInvoiceCalathusId": intInvoiceCalathusId, //intCompanyEntityId BUSQUEDA DE ENTIDADES
                    "intInvoiceType":       intInvoiceType//intEntityTypeId    BUSQUEDA DE ENTIDADES
                }
                /*{    
                    "intRequiredCalathusId" : , // id calathus entidad requerido
                    "intRequiredType"       : ,//tipo clientede requerido
                    "intInvoiceCalathusId"  : , //id calathus entidad facturar a 
                    "intInvoiceType"        : ,// tipo cliente  facturar a
                }
                /*/
                console.log("------REQUEST GENERAR TARIFA--------");
                    console.log(params);
                console.log("---------------");
                const myHeaders = new Headers();
                const resultado =  await fetchData(url, 'POST', myHeaders, params);  
                console.log("-------RESPONSE GENERAR TARIFA--------");
                    console.log(resultado);
                console.log("---------------");
                if(resultado.code === 0){ 
                    setDetail([]); 
                    setDiasAlmacenaje(resultado.rows[0].quantity ? resultado.rows[0].quantity :"");
                    setSubTotal(resultado.rows[0].master.subtotal );
                    setIva(resultado.rows[0].master.tax); 
                    setTotal(parseFloat(resultado.rows[0].master.total));
                    setHasExcedCredit(resultado.rows[0].master.hasExcedCredit) 
                    /** NUEVO  **********************************************/
                        setBlnHasCredit(resultado.rows[0].master.blnHasCredit);
                        setDecCreditLimit(resultado.rows[0].master.decCreditLimit);
                        setCalathuStorageFeeId(resultado.rows[0].master.lngCalathuStorageFeeId);
                    /********************************************************/ 
                    setDtoDiasAlmacenaje(resultado.rows[0].detail);
                    setStrServiceDate(resultado.rows[0].master.serviceDate)
                    setEstado("CAPTURADO");
                    let dias = 0, detalles=[]; 
                    resultado.rows[0].detail.forEach(element => { 
                        dias = dias + parseInt(element.quantity); 
                        let item_detalles = {
                            serviceDate: element.serviceDate ,
                            serviceEndDate:element.serviceEndDate!==undefined && element.serviceEndDate!==null? element.serviceEndDate:"",
                            itemPlDetId: element.itemPlDetailId,
                            description: element.description!==undefined && element.description!==null? element.description:"",
                            descriptionEn: element.descriptionEn!==undefined && element.descriptionEn!==null? element.descriptionEn:"",
                            quantity:element.quantity !== undefined && element.quantity !== null ?element.quantity:0,
                            pct :element.pct,
                            costBase :element.costBase,
                            code:element.code, 
                            weight :element.weight,
                            price:element.price,
                            overcost:element.overcost,
                            discount : element.discount,
                            subtotal :element.subtotal,
                            tax :element.tax,
                            imo :element.imo,
                            sdim :element.sobredim,
                            conven :element.conven,
                            festivo :element.festivo,
                            atado:element.atado,
                            transbordo:element.transbordo,
                            slow:element.slow,
                            domingo:element.domingo,
                            twin:element.twin,
                            full:element.full,
                            secondTurn:element.secondTurn,
                            intitemRow:element.intitemRow,
                            paramCost:element.paramCost
                        }
                        detalles.push(item_detalles); 
                    });
                    setDetail(detalles);
                    setDiasAlmacenaje(dias);
                }else if(resultado.code <= -2){
                    Mensaje(resultado.msg, "warning","top-center",4000); 
                }else{
                    Mensaje(resultado.msg, "warning","top-center",4000);
                    setDetail([]);
                    setDtoDiasAlmacenaje([]);
                } 
                setIsLoading(false); 
        }catch(error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud, ERROR: "+error ,"error","top-center");
        }    
    }

    const handleEntidad = (strrfc, _intBillId, idcompany, nombreentidad, intInvoiceCalathusId, intInvoiceType,type) => { 
        try{
            let lista = ((type === 'aaduanal') ? listaagencias : listaentidades)

            if(strrfc==="" && _intBillId === 0 && idcompany === 0 && nombreentidad === "" && intInvoiceCalathusId > 0 && intInvoiceType > 0){
                return;
            } 
            if( strrfc.trim().length < 10 ){ 
                Mensaje('El RFC de la entidad no es valido por favor comuniquese con el area de Facturación.',"warning","top-center",4000 );
                return;
            }
            if(_intBillId <= 0){ 
                Mensaje('El Billing de la entidad no es valido por favor comuniquese con el area de Facturación.',"warning","top-center",4000 );
                return;
            }
            if(idcompany <= 0){ 
                Mensaje('El identificador de la entidad no es valido por favor comuniquese con el area de Facturación.',"warning","top-center",4000 );
                return;
            } 

            const index = lista.findIndex(item =>  (item.strRFC === strrfc && item.intCompanyId === parseInt(idcompany)) );

            if(strrfc.trim() !== "" && index >= 0 && _intBillId > 0){  
                if(type==='aaduanal'){
                    setRequiredId(lista[index].intCompanyId);
                    setNombreRequired(lista[index].strCompanyName);
                    setRequiredrFC(lista[index].strRFC);
                    setIntRequiredBillId(lista[index].intBillId);
                    setValidaRequired(" is-valid ");

                    if(regfc!== '' && intBillId !== ''){
                        LOG_TOKEN( intBillId,regfc,true,lista[index].intBillId,lista[index].strRFC );
                    } else {
                        
                    }
                     
                    setIntRequiredbyId(intInvoiceCalathusId);
                    setIntRequiredType(intInvoiceType);
                    setReadOnlyRequired(true);      
                               
                }else {
                    // console.log('intCompanyId: ',lista[index].intCompanyId)
                    // console.log('NombreEnt: ',lista[index].strCompanyName)

                    setEntidadId(lista[index].intCompanyId);
                    setNombreEntidad(lista[index].strCompanyName);
                    setRegFC(lista[index].strRFC);
                    setIntBillId(lista[index].intBillId);
                    setValidaEntidad(" is-valid ");

                    if(isEmployee){
                        if(requiredid > 0 && nombrerequired !== '' && intRequiredBillId !== ''){
                            LOG_TOKEN( lista[index].intBillId, lista[index].strRFC );
                        } else {

                        }
                    }else {
                        LOG_TOKEN( lista[index].intBillId, lista[index].strRFC );
                    }
                    //ConsultarSucursales(); 
                    setIntInvoiceCalathusId(intInvoiceCalathusId);
                    setIntInvoiceType(intInvoiceType);
                    setReadOnlyEntidad(true); 
                }
            }else{
                if(type==='aaduanal'){
                    setRequiredId(0)
                    setNombreRequired("")
                    setValidaRequired(" is-invalid ")

                    setIntInvoiceCalathusId(0);
                    setIntInvoiceType(0);
                    
                    setReadOnlyEntidad(false);  
                    setReadOnlyRequired(false)
                    Mensaje('Datos de la entidad incompletos.',"warning","top-center",4000 );
                }else{
                    setEntidadId(0);
                    setNombreEntidad(""); 
                    setValidaEntidad(" is-invalid ");

                    setIntInvoiceCalathusId(0);
                    setIntInvoiceType(0);
                    
                    setReadOnlyEntidad(false);  
                    setReadOnlyRequired(false)
                    Mensaje('Datos de la entidad incompletos.',"warning","top-center",4000 );
                }

            }    
        }catch(err){
            Mensaje('Error:'+err,"error","top-center",4000 );
        } 
    }
 
    const limpiarEntidad = () => {
        setEntidadId(0);
        setNombreEntidad(""); 
        setValidaEntidad("");
        setRegFC("");
          
        setReadOnlyEntidad(false);
        /*BORRA LISTA DE ENTIDADES*/
            setListaEntidades([]);
        /*BORRA CONTENIDO DEL RESULTADO DEL CALCULO*/
            Limpiar_DiasAlmacenaje();
        /* BORRA SUCURSALES */
            setSucursalId(0);
            setDtoSucursales([]);
            setValidaSucursal("");


        setIntInvoiceCalathusId(0);
        setIntInvoiceType(0);    

    }

    const limpiarRequerido= () => {
        setRequiredId(0)
        setNombreRequired("")
        setValidaRequired("")
        setReadOnlyRequired(false)
        setListaAgencias([])

        /*BORRA CONTENIDO DEL RESULTADO DEL CALCULO*/
            Limpiar_DiasAlmacenaje();
        /* BORRA SUCURSALES */
            setSucursalId(0);
            setDtoSucursales([]);
            setValidaSucursal("");

        setIntRequiredbyId(0); 
        setIntRequiredType(0);
        setRequiredrFC("")
        setIntRequiredBillId("")
    }

    const ConsultarEntidad = async(e,nombreentidad,type,mostrar_cortinilla=true)=>{
        try {    
            const keyCode = e.keyCode || e.which;
            //console.log('Letter pressed:',keyCode);
            if ((keyCode < 65 && keyCode > 90) || (keyCode < 97 && keyCode > 122)) {
                return;
            }  
            if(nombreentidad.trim().length < 2 ){
                return;
            } 
            if(mostrar_cortinilla){
                setIsLoading(true); 
            }
            
            setListaEntidades([]);
            setListaAgencias([])
                const url = URL_CALC+SEARCH_COMPANY; 
                const params = {
                    "strname" :nombreentidad.trim()
                } 
               const myHeaders = new Headers();
                 console.log("================== RESQUEST Consultar Entidad =====================")
                     console.log(params);
                console.log("==============================================")
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
                 console.log("================== RESPONCE Consultar Entidad =====================")
                     console.log(resultado);
                 console.log("==============================================")
                if(resultado.code === 0){ 
                    if(type && type === "aaduanal"){
                        setListaAgencias(resultado.rows);
                    }else {
                        setListaEntidades(resultado.rows);
                    }
                }else if(resultado.code <= -2){
                    Mensaje(resultado.msg, "warning","top-center",4000); 
                }else{
                    Mensaje(resultado.msg, "info","top-center",4000);
                } 
                setIsLoading(false); 
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error ,"error","top-center",3500);
        }
    }

    const hadleRechazarCalculo=()=>{
        try {
            setModoCapDoc(2);
            /*setEsRechazarCalculo(false);
            if(!esrechazarcalculo){*/
            setEsRechazarCalculo(esrechazarcalculo = !esrechazarcalculo);
            if(esrechazarcalculo){
                setModoCapDoc(2);
                if(files.length > 0){
                    const index = files.findIndex((item)=>item.intType === 2);
                    if(index >= 0){
                        setMsgFile("") 
                        setMotivoRechazo(files[index].comment)
                        setValidaMotivoRechazo("")
                        setValidaArchivo("")
                        
                        setValidaTipoArchivo("");
                        setPdfName(files[index].strname);
                        setValidaNombreArchivo("");
    
                        setPdfData(files[index].filedata);
                        setPdfFormat(files[index].strextension);
                    } else{
                        setMsgFile("") 
                        setMotivoRechazo("")
                        setValidaMotivoRechazo("")
                        setValidaArchivo("")
                        
                        setValidaTipoArchivo("");
                        setPdfName("");
                        setValidaNombreArchivo("");
        
                        setPdfData("");
                        setPdfFormat("");
                    }    
                }else{
                    setMsgFile("") 
                    setMotivoRechazo("")
                    setValidaMotivoRechazo("")
                    setValidaArchivo("")
                    
                    setValidaTipoArchivo("");
                    setPdfName("");
                    setValidaNombreArchivo("");
    
                    setPdfData("");
                    setPdfFormat("");
                }
                OpenModalRechazarCalculo();
            }else{
                //CerrarModalRechazo();
            }
            //{isOpenModalRechazarCalculo, OpenModalRechazarCalculo, closeModalRechazarCalcul}
        } catch (error) {
            Mensaje("Error al hacer el proceso de rechazo., ERROR: "+error ,"error","top-center",3500);
        }

    }

    const ActualizaRechazarCalculo=()=>{
        if(modo_cap_doc === 2){       
            if(comment.trim().length > 0 && pdfData !== ""){
                setEsRechazarCalculo(true);
            }else{
                setEsRechazarCalculo(false);
            }
        }
    }

    const ConfirmarRechazarCalculo = () => {
  
        if(comment.trim().length > 5){
            setValidaMotivoRechazo(" is-valid ");
        }else{
            setValidaMotivoRechazo(" is-invalid ");
            return;
        } 
       
        if(modo_cap_doc === 3){
            if(pdfData.trim().length > 0){
                setValidaArchivo(" is-valid ");
            }else{
                setValidaArchivo(" is-invalid ");
                return;
            }
        }

        if(pdfname.trim().length > 1){
            setValidaNombreArchivo(" is-valid ");
        }else{
            setValidaNombreArchivo(" is-invalid ");
            return;
        } 
        
        const archivo = {
            strname :pdfname,
            strextension: ".pdf",
            filedata:pdfData,
            comment:comment,
            intType :modo_cap_doc
        }

        if(files.length > 0){
            const index = files.findIndex((item)=>item.intType === modo_cap_doc);
            if(index >= 0){
                files[index] = archivo;
            }else{
                files.push(archivo)
            }
        }else{
            files.push(archivo)
        }

       //// console.log("================== FILES =====================")
       //// console.log(files);
       //// console.log("==============================================")
        ActualizaRechazarCalculo(); 
        if(modo_cap_doc === 2){
            setEsRechazarCalculo(true);
        }
        //CerrarModalRechazo();
        closeModalRechazarCalculo(); 
        if(modo_cap_doc === 3){
            EnviarCalculo();
        }
    }

    const CerrarModalRechazo=()=>{
        
        setMsgFile("")

        setMotivoRechazo("")
        setValidaMotivoRechazo("")
        setValidaArchivo("")
        
        setTipoArchivo(0);
        setValidaTipoArchivo("");

        setEsRechazarCalculo(false);
        
        setPdfName("");
        setValidaNombreArchivo("");

        setPdfData("");
        setPdfFormat("");
        
setIsLoading(false);

        setFilePDF([]);
        closeModalRechazarCalculo();
    }

    const handleMotivoRechazar=(strcomment)=>{
        if(strcomment.trim().length > 5){
            setMotivoRechazo(strcomment);
            setValidaMotivoRechazo(" is-valid ");
        }else{
            setMotivoRechazo(strcomment);
            setValidaMotivoRechazo(" is-invalid ");
            return;
        }
        /*if(strcomment.trim().length >= 0){
            setMotivoRechazo(strcomment);
        }*/
    }

    const Limpiar_DiasAlmacenaje=()=>{
        setIva(0);
        setTotal(0);
        setSubTotal(0);
        setCalathuStorageFeeId(0);
        setDiasAlmacenaje(0);
        setDtoDiasAlmacenaje([]);
        setEsRechazarCalculo(false);
        setFolio("");
        setEstado("");
    }

    const handleCalcularHasta=(value)=>{
        const FACTUAL = new Date();
        const FCalcularHasta = new Date(value);
        const FLibreHasta = new Date(librehasta);
        /*console.log("CalcularHasta: "+value) 
        value="2024-6-5";//value.replaceAll("-","/");
       //// console.log("CalcularHasta: "+value) */
        Limpiar_DiasAlmacenaje();
       /*//// console.log("FACTUAL"+FACTUAL) 
       //// console.log("CalcularHasta"+FCalcularHasta) 
       //// console.log("LibreHasta"+FLibreHasta) 
        */
        if(FCalcularHasta > FLibreHasta ){//&& FCalcularHasta >= FACTUAL){
            if(value.trim() !== ""){
                setCalcularHasta(value);
                setValidaCalcularHasta(" is-valid");
            }else{
                setCalcularHasta(value);
                setValidaCalcularHasta(" is-invalid");
            }
        }else{
            setCalcularHasta(((FACTUAL.getFullYear())+"-"+(FACTUAL.getMonth()<10?("0"+(FACTUAL.getMonth()+1)):FACTUAL.getMonth()+1)+"-"+(FACTUAL.getDate())));
            setValidaCalcularHasta(" is-invalid ");
            Mensaje("La fecha de calcular hasta debe ser mayor a la fecha de libre hasta.","error","top-center",4500);
        }

        
    }

    const EnviarCalculo = async(mostrar_cortinilla=true) => {
        try{
            if(folio > 0){
                Mensaje("Este cálculo ya fue enviado.","warning","top-center",3500);
                return;
            }
            /*if(mostrar_cortinilla){
                setIsLoading(true); 
            }*/
            
            if(esrechazarcalculo === false){ 
                if(files.length>0){
                    const index = files.findIndex((item)=>item.intType === 2);
                    if(index>-1){
                        files.splice(index, 1);
                        //setEsRechazarCalculo(false);
                    }
                } 
            }

            const url = URL_CALC+SEND_CALC; 
           //// console.log(" ============== request SEND CALC ==================== ");
           //// console.log(files);

            if( esrechazarcalculo === true && getReasonReject() === "" ){
                setIsLoading(false);
                Mensaje("No hay un motivo de rechazo asignado.","error","top-center",3500);
                return "";
            }

            const d = new Date();

            const  strWebRequestDate = d.getFullYear()+""+
            ( (d.getMonth()+1) <= 9? '0'+(d.getMonth()+1):(d.getMonth()+1) )+""+
            ( (d.getDate())    <= 9? '0'+(d.getDate())   :(d.getDate()) )+" "+
            
            ( (d.getHours())    <= 9? '0'+(d.getHours())   :(d.getHours()) )+":"+
            ( (d.getMinutes())    <= 9? '0'+(d.getMinutes())   :(d.getMinutes()) )+":"+
            ( (d.getSeconds())    <= 9? '0'+(d.getSeconds())   :(d.getSeconds()) );
            
            
            const params = {
                "lngUniversalId" :lngUniversalId,
                "strRFCInvoice":regfc,
                "intBillIdInvoice":intBillId,
                "strRFCRequired" :isEmployee ? requiredrfc : getUserFiscalIdentifier(),      //String RFC Requerido de quien solicita el servicio
                "intBillIdRequired":  isEmployee? intRequiredBillId : getUserBillingIdentifier(), //Int Id de facturación de quien solicita el servicio
                "intTraffic":intTraffic,
                "strPedimento":"",
                "strnbl":strbl,
                "decSubtotal":subtotal,
                "decTax":iva,
                "decTotal":total,
                "strComment":"",///comentarios de la factura
                "strReference":strreferencia,
                "strReferenceCustomer" : "",
                "intCustomerAddresId" :sucursalid,
                    "strPayMethod" :null,
                    "strPayForm" :null,
                    "strCFDIUsage":null,
                "strServiceDate":strServiceDate,
                "intCurrency":moneda,
                "strusername" :getUserName(),
                 
                "saleDetail" :detail,
                "files":files,
                  
                "blReject" : esrechazarcalculo,//false,  //<------ es rechazado el calculo
                "blreview" : files.length > 0? true : false,  //
                "decCreditLimit": decCreditLimit ,
                "strReason": esrechazarcalculo?  getReasonReject() : "",    // razón del rechazo
                "lngCalathuStorageFeeId":calathuStorageFeeId, //ID CALCULO DE ALMACENAJE
                "strWebRequestDate":strWebRequestDate,
            }           
            const myHeaders = new Headers();  
           //// console.log(params);
            console.log(" ===================================================== ");
                console.log("-------REQUEST GENERAR TARIFA--------");
                console.log(params);
            console.log("---------------");
            const resultado =  await fetchData(url, 'POST', myHeaders, params); 
            if(resultado.code === 0){ 
                console.log("------- response SEND CALC  ---------------------- ");
                    console.log(resultado);
                console.log("-------------------------------------------------- ");
                //Mensaje("RESULTADO: "+resultado.rows[0].result+" - FOLIO: "+resultado.rows[0].folio +"-"+" COMMENT: "+resultado.rows[0].comment, "success","top-center",3500);
                Mensaje("El cálculo de almacenaje fue creado exitosamente con el folio: "+resultado.rows[0].folio, "success","top-center",3500);
                downloadPdf(resultado.rows[0].FileData, ("REPORTE_"+resultado.rows[0].folio+" - "+getUserName()));
                setLibreHasta(resultado.rows[0].FreeUntil)
                setFolio(resultado.rows[0].folio);
                setEstado("ENVIADO")
                GetCalcSumarys(lngUniversalId);
            }else if(resultado.code <= -2){
                Mensaje(resultado.msg, "warning","top-center",4000); 
            }else{
                Mensaje(resultado.msg+" - "+resultado.errortext, "info","top-center",4000);
            }
            /**/setIsLoading(false); 
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error ,"error","top-center");
        } 
    } 

    const NuevoCalculo = () => {
        Limpiar_Campos();

        setStrReferencia("");
        setValidaReferencia("");
        setValidaContenedor("");
        setContenedor("");
        setValidaBl("");
        setStrBl("");
        Limpiar_DiasAlmacenaje();
    }
 
    const SolicitarComprobantePago=()=>{
        try{
            setModoCapDoc(3);
            if(files.length > 0){
                const index = files.findIndex((item)=>item.intType === 3);
                if(index >= 0){ 
                    setMsgFile("") 
                    setMotivoRechazo(files[index].comment)
                    setValidaMotivoRechazo("")
                    setValidaArchivo("")
                    
                    setValidaTipoArchivo("");
                    setPdfName(files[index].strname);
                    setValidaNombreArchivo("");

                    setPdfData(files[index].filedata);
                    setPdfFormat(files[index].strextension);
                } else{ 
                    setMsgFile("") 
                    setMotivoRechazo("")
                    setValidaMotivoRechazo("")
                    setValidaArchivo("")
                    
                    setValidaTipoArchivo("");
                    setPdfName("");
                    setValidaNombreArchivo("");
    
                    setPdfData("");
                    setPdfFormat("");
                }    
            }else{ 
                setMsgFile("") 
                setMotivoRechazo("")
                setValidaMotivoRechazo("")
                setValidaArchivo("")
                
                setValidaTipoArchivo("");
                setPdfName("");
                setValidaNombreArchivo("");

                setPdfData("");
                setPdfFormat("");
            }

            
            OpenModalRechazarCalculo();
        }catch (error) {
            Mensaje("Error al intentar abrri el modal de comprobante de pago, ERROR: "+error ,"error","top-center");
        } 
    }

    const Send_Calc = async() => {
        try{ 
            setIsLoading(true);
            if( blnHasCredit ){// El agente tiene credito
                //const AvaliableCredit = decAvaliableCredit();
                    if( parseInt(getUserID()) < 0 ){ 
                        Mensaje('El RFC de la entidad no es valido por favor comuniquese con el area de Facturación.',"warning","top-center",4000 );
                        return;
                    }
                    //LOG_TOKEN();
                    const url = URL_CONSULTAR_BALANCE;  
                        const params = {
                            "id": isEmployee ? intRequiredBillId : getUserBillingIdentifier(),//getUserID(),
                        }
                        console.log("-------request CONSULTAR BALANCE--------");
                            console.log(params);
                        console.log("---------------");
                            const myHeaders = new Headers();
                            if(strtok !== ""){
                                myHeaders.append("Content-Type", 'application/json');  
                                myHeaders.append("Authorization", ('Bearer '+strtok) );
                            } 
                        const resultado =  await fetchData(url, 'POST', myHeaders, params);  
                        if(resultado !== null && resultado !== undefined){ 
                                 console.log("-------response CONSULTAR BALANCE--------");
                                    console.log(resultado);
                                    //alert("SALDO ACTUAL: "+resultado);
                                 console.log("---------------");

                                setBalance(resultado);
                                if( (resultado > 0) ){//TIENE CREDITO Y TIENE SALDO IGUAL O MAYOR.
                                    if((decCreditLimit*0.05)< resultado){
                                        //Mensaje("EL SALDO DISPONIBLE DE SU LINEA DE CREDITO SE ENCUENTRA POR DEBAJO DEL 5%, LE RECOMENDAMOS REALIZAR SUS PAGOS PARA EVITAR INCONVENIENTES, DISPONIBLE"+resultado, "warning","top-center",15000);
                                        setMensajeSaldo("EL SALDO DISPONIBLE DE SU LINEA DE CREDITO SE ENCUENTRA POR DEBAJO DEL 5%, LE RECOMENDAMOS REALIZAR SUS PAGOS PARA EVITAR INCONVENIENTES, DISPONIBLE"+resultado);
                                    }
                                    EnviarCalculo();
                                }else if( (resultado <= 0) ){//TIENE CREDITO PERO SALDO NEGARTIVO O IGUAL A CERO. 
                                    setIsLoading(false);
                                    SolicitarComprobantePago();
                                }
                                //setIsLoading(false);
                                
                        }else if(resultado.code <= -2){
                            Mensaje(resultado.msg, "warning","top-center",4000); 
                        }else{
                                Mensaje(resultado.msg, "info","top-center",4000);
                                setDetail([]);
                                setDtoDiasAlmacenaje([]);
                                //setIsLoading(false); 
                        }
            }else{//no tiene credito
                setIsLoading(false);
                SolicitarComprobantePago();
            }
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error ,"error","top-center");
            setIsLoading(false);
        } 
    }
    
    const getReasonReject = () => {
        try {
            if(files.length > 0){
                const index = files.findIndex((item)=>item.intType === 2);
                if(index >= 0){
                    if (files[index].comment.trim() !== "" ){
                        return files[index].comment
                    }else{
                        Mensaje("No hay un motivo de rechazo asignado.","error","top-center",3500);
                        return "";
                    }

                }else{
                    Mensaje("No hay un motivo de rechazo asignado.","error","top-center",3500);
                    return "";
                }
            }else{
                Mensaje("No hay un motivo de rechazo asignado.","error","top-center",3500);
                return "";
            }
        } catch (error) {
            Mensaje("Se ha presentado un error: "+error,"error","top-center",3500);
                
        }
    }

    const [strtok,setStrTok] = useState("");
    const LOG_TOKEN = async( _intBillId = 0, _strRFC = 0, mostrar_cortinilla=true,_intRequiredBillId,_requiredrfc)=>{  //tokonly=false
        try{
            if(mostrar_cortinilla){
                setIsLoading(true); 
            } 
                const url = URL_LOGIN_SUCURSALES; 
                const params =  {
                    "userName" : USER,
                    "password" : PSW
                }           
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                
                const resultado =  await fetchData(url, 'POST' , myHeaders, params); 
                if(resultado.token !== "" && resultado.token !== undefined){  
                    setStrTok(resultado.token);
                    if(_intBillId>0 && _strRFC!==""){
                        ConsultarSucursales( 
                            _intBillId, _strRFC, 
                            isEmployee ? (_intRequiredBillId ? _intRequiredBillId : intRequiredBillId) : getUserBillingIdentifier(), 
                            isEmployee ? (_requiredrfc ? _requiredrfc : requiredrfc) : getUserFiscalIdentifier(),
                            resultado.token); 
                    }
                }else if(resultado.code <= -2){
                    Mensaje(resultado.msg, "warning","top-center",4000); 
                }else{
                    Mensaje(resultado.msg, "info","top-center",4000);
                }   
                setIsLoading(false);
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.messaje ,"error","top-center");
        } 
    }
       
    const ConsultarSucursales = async(clientId, rfcClient, agentId, rfcAgent, _strtok,mostrar_cortinilla=true )=>{ 
        try{ 
            setValidaEntidad("");
            const url = URL_CONSULTAR_SUCURSALES; 
            const params =  {
                "clientId" : clientId, //intBillId,//entidadid,
                "rfcClient" : rfcClient,//regfc, 
                "agentId" : agentId,//getUserBillingIdentifier(),
                "rfcAgent" : rfcAgent//getUserFiscalIdentifier(),
            }
            const myHeaders = new Headers();
            if(_strtok !== ""){
                myHeaders.append("Content-Type", 'application/json');  
                myHeaders.append("Authorization", ('Bearer '+_strtok) );
              } 
            const resultado =  await fetchData(url, 'POST',myHeaders,params); 
            setValidaEntidad("");
            setValidaSucursal("");
            if(resultado.result){ 
                if(resultado.address !== null){
                    setSucursalId(0);
                    setDtoSucursales(resultado.address)

                    if(resultado.address.length===1 ){
                        setSucursalId( resultado.address[0].customerAddressId );
                        setValidaEntidad(" is-valid ");
                        setValidaSucursal(" is-valid ");
                    }else{
                        setSucursalId(0);
                        setValidaEntidad(" is-valid ");
                        setValidaSucursal("");
                    }

                }else{
                    Mensaje(resultado.comment,"error","top-center",4500);
                    setValidaEntidad(" is-invalid ");
                    setValidaSucursal(" is-invalid ");
                    setSucursalId(0);
                    setDtoSucursales([])
                }
                setIsLoading(false); 
            }else{
                Mensaje(resultado.comment, "error","top-center",4000);
                setValidaEntidad(" is-invalid ");
                setValidaSucursal(" is-invalid ");
                setIsLoading(false); 
            } 
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.messaje ,"error","top-center");
        } 
    }
    
    const hadleSucursal = (sucursalid) => {
        try {
            Limpiar_DiasAlmacenaje();
            if(sucursalid > 0 ){
                setSucursalId(sucursalid);
                setValidaSucursal(" is-valid ");
            }else{
                setSucursalId(0);
                setValidaSucursal(" is-invalid ");
            }               
        } catch (error) {
            Mensaje("Ocurrio un error al momento de asignar la sucursal, Error: "+error.Messaje,"error","top-center",3500);
        }
    }

    const hadleMoneda = (value) => {
        try {
            Limpiar_DiasAlmacenaje();
            if(value > 0 ){
                setMoneda(parseInt(value));
                setValidaMoneda(" is-valid ");
            }else{
                setMoneda(0);
                setValidaMoneda(" is-invalid ");
            }               
        } catch (error) {
            Mensaje("Ocurrio un error al momento de asignar una moneda, Error: "+error.Messaje,"error","top-center",3500);
        }
    }

    const hadleTipoTrafico = (value) => {
        try {
            Limpiar_DiasAlmacenaje();
            if(value > 0 ){
                setIntTraffic(parseInt(value));
                setValidaIntTraffic(" is-valid ");
            }else{
                setIntTraffic(0);
                setValidaIntTraffic(" is-invalid ");
            }               
        } catch (error) {
            Mensaje("Ocurrio un error al momento de asignar el tipo de trafico, Error: "+error,"error","top-center",3500);
        }
    }

    const HandleNombreArchivo = (value) => {
        try {
            if(value.length > 0 ){
                setPdfName(value);
                setValidaNombreArchivo(" is-valid ");
            }else{
                setPdfName("");
                setValidaNombreArchivo(" is-invalid ");
            }               
        } catch (error) {
            Mensaje("Ocurrio un error al momento de asignar el tipo de documento, Error: "+error,"error","top-center",3500);
        }
    }

    const FormatoMoneda = (props) => {
        return (   
            <span className="px-1">{Formato_Moneda(props.costBase)}</span>
        ) 
    }
    const FormatoMoneda2 = (props) => {
        return (   
            <span className="px-1">{Formato_Moneda(props.subtotal)}</span>
        ) 
    }

    const FormatoMoneda3 = (props) => {
        return (   
            <span className="px-1">{Formato_Moneda(props.overcost)}</span>
        ) 
    }

    const bandera = () => {
        
            if(moneda === 1){
                return <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 64 64"><path fill="#ed4c5c" d="M62 32c0-13.1-8.3-24.2-20-28.3v56.6C53.7 56.2 62 45.1 62 32"/><path fill="#75a843" d="M2 32c0 13.1 8.4 24.2 20 28.3V3.7C10.4 7.8 2 18.9 2 32"/><path fill="#fff" d="M42 3.7C38.9 2.6 35.5 2 32 2s-6.9.6-10 1.7v56.6c3.1 1.1 6.5 1.7 10 1.7s6.9-.6 10-1.7z"/><path fill="#75a843" d="M40.7 31.7c-.1-.3-.2.1-.2.2c0-.3-.1-.5-.3-.8c-.3.3-.4.7-.4 1.1c-.1-.3-.2-.6-.5-.7c.2.3.1.5.1.8c0 .4.3.7.3 1.1c0 .4-.2.7-.5 1v-.3c-1 .4-.8.9-.8 1.8s-.5.7-1.1 1.2c.1-.2.1-.5 0-.7c0 .6-.8.6-.9 1.1c-.1.2 0 .6-.3.7c-.2.1-.5.3-.5.5c-.2-.1-.4-.1-.7-.1c.1-.1.2-.1.3-.2c-1-.5-1.3.6-2.2.7c-.3 0-1-.4-1 0c.9 0 1.3.8 2 .8c.6 0 1.1-.5 1.7-.5c-.1 0-.4-.2-.7-.2c.5-.3.8-.9 1.4-.9c1 0 1.5-.2 1.8-1.2c-.1 0-.2 0-.3.1c0-.4.4-.9.8-1.1c1-.2.9-1 1.5-1.7c-.2 0-.4.1-.6.3c0-.6-.1-1.2.4-1.6c1-.5.9-.7.7-1.4m-17.4 0c-.2.8-.3 1 .5 1.5c.6.4.4 1 .4 1.6c-.2-.2-.3-.3-.6-.3c.6.6.5 1.5 1.5 1.7c.3.2.8.7.8 1.1c-.1 0-.2-.1-.3-.1c.3 1 .8 1.2 1.8 1.2c.6 0 .9.6 1.4.9c-.3 0-.6.1-.7.2c.6 0 1.1.6 1.7.5c.7 0 1.2-.8 2-.8c0-.4-.7 0-1 0c-.8-.2-1.1-1.2-2.2-.8c.1.1.2.2.3.2c-.2 0-.5-.1-.7.1c-.1-.2-.3-.4-.5-.5c-.2-.2-.2-.5-.3-.7c-.2-.5-.9-.6-.9-1.1c-.1.2-.1.5 0 .7c-.6-.5-1.1-.3-1.1-1.2c0-.8.2-1.4-.8-1.8v.3c-.3-.3-.5-.5-.5-1c0-.4.4-.7.3-1.1c0-.3-.1-.5.1-.8c-.3.1-.4.4-.5.7c0-.4-.1-.8-.4-1.1c-.1.2-.2.5-.3.8c.1-.2 0-.5 0-.2m2.3 5"/><path fill="#428bc1" d="M34.7 37.7c-.2 0-.3-.2-.4-.3c0-.2.8-.4.9-.4v-.2c-1.3.4-5.2.7-6-.7c-.4.6-1.1.2-1.8-.3c.1.2.5 1.2.5 1.1c.2.1 1.5.4 1.5.7l-.3.3c2.1.7 3.4.9 5.6-.2"/><path fill="#ed4c5c" d="M33.4 37.7c.1-.1.1-.2.1-.4l-.1-.3c.2-.2 0-.7-.3-.6c-.2.1-.1.1-.3 0c-.1 0-.1-.1-.2-.1h-1.8c-.2 0-.2-.1-.4-.1c-.2-.1-.3.1-.4.2c0 .2.1.2.1.3c0 .1-.1.2-.1.4s.1.3.2.4c-.4.3 0 .8.4.5c.1.2.4.2.7.2h1.1c.2 0 .6.1.7-.2c.3.5.7-.1.3-.3"/><path fill="#428bc1" d="M36.6 35.1c-.8-1-1.2.5-2.1.4c.2-1.2-1.6-.8-2.1-.5c.1-.1.2-.3.3-.5c-.4 0-.9.2-1.2-.1c-.6-.4-1.4-.6-1.9.1c-.4-.6-1.5-1.2-2.1-.6c0-.6-.6-1.5-1.3-1.4c-.8.1-.5 1.1-.1 1.5c.3.3.7.4 1.1.4c0 .2.1.3.2.4c.5.4 1.5.5 2 .1c0 1 2 1 2.5.5c-.2.5-.4 1.5.3 1.5c.6 0 .4-.6.9-.8c.4-.2.9-.3 1.3-.1c.7.4 2.9.3 2.2-.9"/><g fill="#75a843"><path d="M28.4 32.6c-.1-.2-.3-.4-.3-.4c-.4.1-.4-.2-.5-.5c-.1-.5-.8-.7-.8-1.1c0-.4.4-.8.1-1.2c-.3-.4-.8-.6-.8-.4c-.1.2.4.2.4.7c0 .6-.6 1.1.1 1.6c.4.6.4 1.7 1.1 1.7c.3 0 .6-.1.7-.4"/><path d="M29.9 32.1c-.2-.4 0-1-.4-1.3c-.5-.4-1.5.4-1.6-.6c0-.2 1.1-1.4 1.3-1.5c.3-.4.2-1.1-.1-1.3c-.4-.2-.5 0-.8.4c.1.1.5.3.5.4c-.3.7-1.2.8-1.4 1.5c-.2.5-.1 1.3.4 1.6c.3.2.5.2.8.2c.9-.1.4.1.5.3c0 .2.3.9.8.3m-3-4.9c0 .6.6.5 1 .4c0-.2 0-.4.1-.6c-.2.1-.5.1-.6 0c-.3-.2.7-.6.6-.6c0 0-1 .5-.6-.1c.1-.2.3-.4.4-.6c.1-.2-.3 0-.3 0c-.1 0-.2 0-.3.1c-.6.5-.4.8-.3 1.4"/></g><path fill="#89664c" d="M37.5 27.2c-.5-.7-2.4-3-5.1-3.2c-.3 0-1.1.3-1.4.4c-.9.6 1 1.1 1.1 1.5c0 .2.1.3.1.5c-.3-.5-.6-.8-.7-1c-.5.2-1.3-.1-1.4-.6c-.1.2-.1.3-.3.5c0-.3-.1-.3-.2-.5c0 .3 0 .7-.3.8c.1-.2 0-.4-.1-.6c0 .3 0 .5-.2.7c.1-.2-.1-.3-.1-.5c-.1.8-1.2 1.1-.1 1.4c.4.1.6 0 1 .2c.1.1.3.3.3.2c0 .1-.4.5-.1.6c-.1.1-.4.7-.4.7c.3 0 .1.2-.1.4c-.3.5 0 1 .1 1.6c0-.2.3.1.3.4c0 .4.4.6.5.9c-.5-.5-.6 0 0 .3c-.5 0-.6.3-.1.5c-1.2 0-.2.5 0 .6c.8.2 1.4-.4 1.4-.5c0 0 1.6 1.6 1.7 1.6c.1 0 .9-.4 1.1-.2c.2.3.4 0 .6.1c.2.2 1 0 1.2-.1c.1 0 1.1-.2.9-.4c-.5-.4-1.1-.8-1.6-1.2c-.5-.4-1-.7-1.4-1.1c-.2-.2-.2-.6-.3-.9c.9.9 1.8 1.4 1.7-.3c.6.5 1.8 3.3 1.9 3.3c.3 0 0-3 0-3.3c.4.4.4 3.7.5 3.7c.5.1 1.2-4.3-.5-6.5"/><path fill="#ffce31" d="M30.3 32.3c-.1 0-.6-.7-.6-.8c.3 1.2-.9.5-.6 0c-.4-.1-1.4.5-1 1.1c-.2.4 1.4.1 1.5-.1c.4.9 1.4-.1.7-.2m4.7 3c.5-.7-1.6-.9-1.4-1.7c-.3.2-.7.9-1.1.7c-.2-.1-1 .4-.6.7c0-.4.2-.1.5-.2c-.1.3-.4.6.1.8c-.2-.6.6-.3.5-.6c-.2-.2.7-.2.8-.2c.3 0 1.3.3.9.6c0 0 .2 0 .3-.1m-6.7-8.6c-.1.2-.5.5-.5.8c0 .2.5.7.7.4c-.6-.4.1-.7.4-.7c.1 0 .1.2.1.2c.1.1.9-.2.8-.4c.1-.4-1.2-.4-1.5-.3m0 0"/></svg>
            }else{
                return    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512"><mask id="IconifyId1900e73e518d091603"><circle cx="256" cy="256" r="256" fill="#fff"/></mask><g mask="url(#IconifyId1900e73e518d091603)"><path fill="#eee" d="M256 0h256v64l-32 32l32 32v64l-32 32l32 32v64l-32 32l32 32v64l-256 32L0 448v-64l32-32l-32-32v-64z"/><path fill="#d80027" d="M224 64h288v64H224Zm0 128h288v64H256ZM0 320h512v64H0Zm0 128h512v64H0Z"/><path fill="#0052b4" d="M0 0h256v256H0Z"/><path fill="#eee" d="m187 243l57-41h-70l57 41l-22-67zm-81 0l57-41H93l57 41l-22-67zm-81 0l57-41H12l57 41l-22-67zm162-81l57-41h-70l57 41l-22-67zm-81 0l57-41H93l57 41l-22-67zm-81 0l57-41H12l57 41l-22-67Zm162-82l57-41h-70l57 41l-22-67Zm-81 0l57-41H93l57 41l-22-67zm-81 0l57-41H12l57 41l-22-67Z"/></g></svg>
            
            }
        
    }

    const Formato_Moneda = (value) => {
        try {
            const num = parseFloat(value);
            const formattedCurrency = num.toLocaleString( 'mx-Es', { style: 'currency', currency: 'MXN'}); 
            return (formattedCurrency );
        } catch (error) {
            Mensaje("Error al tratar de dar formato moneda.","error","top-center",3500);
        }
         
    }

    const Descripcion =(props)=>{
        return( <span title={props.description}>{props.description}</span>);
    }
     
    const cellMoneda = FormatoMoneda;
    const cellMoneda2 = FormatoMoneda2; 
    const cellMoneda3 = FormatoMoneda3; 

    const cellDescripcion = Descripcion; 
     
    const cellDownload = (props) => {
        return ( 
            <span className="rowControls">
                <button id={"pdf-"+props.intStorageFeeId}    className={`pdf-${props.intStorageFeeId} btn btn-opcion p-0 m-0`} title="Descargar PDF del calculo" onClick={()=>{DownloadPdf(props.intStorageFeeId,props.strFeeType)}} >
                    <Icono  icono={"PDF"}  width={"20"} height={"20"} fill="#dc3545"/>
                </button>
            </span> 
        ) 
    }

    const DownloadPdf = async(intStorageFeeId,strFeeType, mostrar_cortinilla=true) => { 
        try {  

            if(mostrar_cortinilla){
                setIsLoading(true); 
            }

            if(!(parseInt(intStorageFeeId)>0)){
                return
            }
                const url = URL_CALC+GETREPORT; 
                const params = {
                    "lng_RptStorageFeeCalc":intStorageFeeId,
                    "str_UserName" : getUserName(),
                } 
                const myHeaders = new Headers();
                const resultado = await fetchData(url, 'POST', myHeaders, params); 
                if(resultado.code === 0){ 
                   downloadPdf(resultado.rows[0].dataFile, (strFeeType+"_"+intStorageFeeId+" - "+getUserName())); 
                }else if(resultado.code <= -2){
                    Mensaje(resultado.msg, "warning","top-center",4000); 
                }else{
                    Mensaje(resultado.msg, "info","top-center",4000);
                } 
                setIsLoading(false); 
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error ,"error","top-center",3500);
        }
    }
    const ColumnDownload = cellDownload; 
    const [fecha_hasta,setFechaHasta] = useState("");
        useEffect(()=>{
        
        if(librehasta!==""){
            let date_librehasta = new Date(librehasta.replaceAll("-","/"));
            let date_actual = new Date();
            if( date_librehasta > date_actual  ){
                let mindate = new Date((librehasta.replaceAll("-","/")));
                mindate.setDate( mindate.getDate() + 1 );
                setFechaHasta(((mindate.getFullYear())+"-"+((mindate.getMonth()+1) < 10 ?("0"+(mindate.getMonth()+1)):mindate.getMonth()+1)+"-"+(mindate.getDate() >= 10 ? mindate.getDate() : '0'+mindate.getDate() )));
                setCalcularHasta( (((mindate.getFullYear())+"-"+((mindate.getMonth()+1) < 10 ?("0"+(mindate.getMonth()+1)):mindate.getMonth()+1)+"-"+( mindate.getDate() >= 10 ? mindate.getDate() : '0'+mindate.getDate()  ))) )
            }else{
                let mindate = new Date();
                mindate.setDate( mindate.getDate()  );
                setFechaHasta(((mindate.getFullYear())+"-"+((mindate.getMonth()+1) < 10 ?("0"+(mindate.getMonth()+1)):mindate.getMonth()+1)+"-"+(mindate.getDate() >= 10 ? mindate.getDate() : '0'+mindate.getDate() )));
                setCalcularHasta( (((mindate.getFullYear())+"-"+((mindate.getMonth()+1) < 10 ?("0"+(mindate.getMonth()+1)):mindate.getMonth()+1)+"-"+(mindate.getDate() >= 10 ? mindate.getDate() : '0'+mindate.getDate() ))) )
            }      
        }else{
            const d = new Date();
            d.setDate( d.getDate() );
            setFechaHasta(((d.getFullYear())+"-"+((d.getMonth()+1) < 10 ?("0"+(d.getMonth()+1)):d.getMonth()+1)+"-"+(d.getDate())));
        }   
     
            
    },[librehasta,calcsumarys]);
    return(
        <>
            <Tabs > 
                <TabList>
                    <Tab key={"opcion_generar"}> 
                        <label htmlFor="">GENERAR</label>
                    </Tab>
                    <Tab key={"opcion_consultar"}> 
                        <label htmlFor="">CONSULTAR</label>
                    </Tab>
                </TabList>
                    <TabPanel key={"panel_generar"}> 
                        <div id="calcular_almacenaje" >{/*</TabPanel>style={{display:"none"}}>*/}
                            <p className="h4 al" >GENERAR DE ALMACENAJE</p>
                            <hr className="p-0 m-0" />
                            <div className={`div_diabled`}></div>
                            <div className="row ">
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                                            <div className="form-check">
                                                <label className={`form-check-label `} htmlFor="esimo">
                                                    ES IMO
                                                </label>
                                                <input id="esimo" className="form-check-input"  type="checkbox" checked={esimo} readOnly onChange={()=>{}} />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                                            <div className="form-check">
                                                <label className={`form-check-label` } htmlFor="essobredimension">ES SOBREDIMENSIONAMIENTO</label>
                                                <input className="form-check-input" type="checkbox" checked={sobredimension} id="essobredimension" readOnly onChange={()=>{}} />
                                            </div>
                                        </div>
                                    </div> 
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <label className="mx-0 px-0" htmlFor="ref">BUQUE VIAJE:</label>
                                    <label id="txtbuque_viaje" className={`form-control form-control-sm `}>{buqueviaje}</label>
                                </div>   
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <label className="mx-0 px-0" htmlFor="ref">TIPO DE TRAFICO:</label>
                                    <select name="slctipotrafico" id="slctipotrafico" 
                                    className={`form-select form-select-sm ${validatIntTraffic}`} onChange={(evt)=>{hadleTipoTrafico(evt.target.value)} } value={intTraffic}
                                    >
                                    { tipostraficos ?
                                        <>
                                            
                                            {tipostraficos.map((item)=>(
                                                <option  key={item.intFiscalMovId} value={item.intFiscalMovId}> {` ${item.strFiscalMov} - ${item.strFiscalDescription} `} </option>
                                            ))}
                                        </>
                                        :<option value="-1">No se encontraron tipos de traficos.</option>
                                    }
                                    </select>
                                    
                                </div>   

                                <div className="col-12 ">    
                                    <div className="row"> 
                                    {isEmployee ? 
                                    <>
                                        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                            <div className="row mx-0">  
                                                <div className={`col-11 p-0 m-0 ${validarequired}`  } >
                                                    <DatalistInput 
                                                        placeholder="Seleccione una entidad..."
                                                        value={nombrerequired} 

                                                        onSelect={(item) => { 
                                                            handleEntidad(item.strrfc, item.intBillId, item.idcompany, item.value, item.intInvoiceCalathusId, item.intInvoiceType, 'aaduanal')
                                                        } }
                                                        
                                                        onKeyUp={(ev)=>{ ConsultarEntidad(ev, ev.target.value,'aaduanal')}}
                                                        
                                                        style={{border:"none"}}
                                                        label="SOLICITADO POR:"
                                                        showLabel={true}
                                                        items={  
                                                            listaagencias?
                                                                listaagencias.map((el,index)=>( 
                                                                    {key:index ,strrfc: el.strRFC, intBillId: el.intBillId, idcompany: el.intCompanyId , intInvoiceCalathusId: el.intCompanyEntityId, intInvoiceType:el.intCustomerTypeId,
                                                                        value:
                                                                            el.intCustomerTypeId  === 1? "CLIENTE - " + el.strCompanyName
                                                                            :el.intCustomerTypeId === 2? "CONSIGNATARIA - " + el.strCompanyName
                                                                            :el.intCustomerTypeId === 3? "LINEA NAVIERA  - " + el.strCompanyName
                                                                            :el.intCustomerTypeId === 4? "AGENCIA ADUANAL - " + el.strCompanyName
                                                                            :el.intCustomerTypeId === 5? "TRANSPORTISTA - " + el.strCompanyName
                                                                            :""}
                                                            )): [{key:0,strrfc:"", intBillId: 0, idcompany: 0, value: "" }]
                                                        }
                                                        labelProps={{
                                                            className:"m-0 p-0",
                                                        }} 
                                                        inputProps={{
                                                            className:('form-control form-control-sm'+validarequired),
                                                            readOnly: readOnlyrequired,
                                                        }} 
                                                        listboxProps={{ 
                                                            className:('fw-bold listboxProps'),
                                                        }}
                                                    />
                                                </div> 
                                                <div className="col-1 btn_borrar_item_lista mb-1 pb-1">
                                                    <button className="btn-close " title="BORRAR CONTENIDO" onClick={limpiarRequerido}></button>
                                                </div> 
                                            </div>
                                        </div>
                                    </> : <></>}    

                                        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                            <div className="row mx-0">  
                                                <div className={`col-11 p-0 m-0 ${validaentidad}`  } >
                                                    <DatalistInput 
                                                        placeholder="Seleccione una entidad..."
                                                        value={nombreentidad} 

                                                        onSelect={(item) => { handleEntidad(item.strrfc, item.intBillId, item.idcompany, item.value, item.intInvoiceCalathusId, item.intInvoiceType)} }
                                                        
                                                        onKeyUp={(ev)=>{ ConsultarEntidad(ev, ev.target.value) }}
                                                        
                                                        style={{border:"none"}}
                                                        label="FACTURAR A:"
                                                        showLabel={true}
                                                        items={  
                                                            listaentidades?
                                                                listaentidades.map((el,index)=>( 
                                                                    {key:index ,strrfc: el.strRFC, intBillId: el.intBillId, idcompany: el.intCompanyId , intInvoiceCalathusId: el.intCompanyEntityId, intInvoiceType:el.intCustomerTypeId,
                                                                        value:
                                                                            el.intCustomerTypeId  === 1? "CLIENTE - " + el.strCompanyName
                                                                            :el.intCustomerTypeId === 2? "CONSIGNATARIA - " + el.strCompanyName
                                                                            :el.intCustomerTypeId === 3? "LINEA NAVIERA  - " + el.strCompanyName
                                                                            :el.intCustomerTypeId === 4? "AGENCIA ADUANAL - " + el.strCompanyName
                                                                            :el.intCustomerTypeId === 5? "TRANSPORTISTA - " + el.strCompanyName
                                                                            :""}
                                                            )): [{key:0,strrfc:"", intBillId: 0, idcompany: 0, value: "" }]
                                                        }
                                                        labelProps={{
                                                            className:"m-0 p-0",
                                                        }} 
                                                        inputProps={{
                                                            className:('form-control form-control-sm'+validaentidad),
                                                            readOnly: readOnlyentidad,
                                                        }} 
                                                        listboxProps={{ 
                                                            className:('fw-bold listboxProps'),
                                                        }}
                                                    />
                                                </div> 
                                                <div className="col-1 btn_borrar_item_lista mb-1 pb-1">
                                                    <button className="btn-close " title="BORRAR CONTENIDO" onClick={limpiarEntidad}></button>
                                                </div> 
                                            </div>
                                        </div>
                                    
                                        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                                            <label className="mx-0 px-0" htmlFor="ref">RFC:</label>
                                            <label id="lblregfc"className={`form-control form-control-sm ${validaentidad}`}>{regfc}</label> 
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                                            <label className="mx-0 px-0" htmlFor="ref" >SUCURSAL SI SE REQUIERE:</label>
                                            <select className={`form-select form-select-sm ${validasucursal}`} onChange={(evt)=>{hadleSucursal(evt.target.value)} } value={sucursalid} name="slcsucursal" id="slcsucursal">
                                                { dtosucursales ?
                                                    <>
                                                    <option key="0" value="0">seleccione una sucursal... </option> 
                                                    {dtosucursales.map((item)=>(
                                                        <option  key={item.customerAddressId} value={item.customerAddressId}> {` ${item.postalCode} - ${item.estadoDesc} - ${item.countryDesc} `} </option>
                                                    ))
                                                    }
                                                    </>
                                                    :<option value="-1">No se encontraron sucursales.</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    
                                    

                                    <div className="row ">
                                        <div className="col-6 ">
                                            <label className="mx-0 px-0" htmlFor="librehasta">CALCULAR HASTA: { fecha_hasta }</label>
                                            <input 
                                                id="librehasta" 
                                                type="date" 
                                                autoComplete={"off"} 
                                                format={"dd/mm/yyyy"} 
                                                className={`form-control form-control-sm ${validacalcularhasta} `} 
                                                value={calcularhasta} 
                                                onChange={(evt)=>{handleCalcularHasta(evt.target.value)}}
                                                min={fecha_hasta} 
                                            />
                                        </div> 
                                        <div className="col-6 ">
                                            <label className="mx-0 px-0" htmlFor="librehasta">MONEDA:</label>
                                            <select className={`form-select form-select-sm ${validiamoneda}`} onChange={(evt)=>{hadleMoneda(evt.target.value)} } value={moneda} name="slcmoneda" id="slcmoneda">
                                                <option key="1" value="1">PESO MEXICANO MXN</option>
                                                {/*<option key="2" value="2">DOLARES USD</option>*/}
                                            </select>
                                        </div>    
                                    </div>
                                    
                                    <div className="row my-3">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">    
                                            {
                                                entidadid > 0 && sucursalid > 0 && regfc.trim() !== "" && calcularhasta.trim() !== ""? 
                                                <button className={`btn text-bg-primary float-end col-12  `}
                                                onClick={Generar_Tarifa} data-bs-toggle="tooltip" data-bs-placement="top" title="Tooltip on top">CALCULAR ALMACENAJE</button> 
                                                
                                                :<button className={`btn text-bg-primary float-end col-12 disabled `}
                                                disabled >CALCULAR ALMACENAJE</button> 
                                            }
                                            
                                        </div> 
                                    </div>
                                </div>
                            </div>
                            {/*const [modo_cap_doc,setModoCapDoc] = useState(0);//1. Archivos de expediente // 2. Archivos de rechazo // 3. Comprobantes de pago*/}
                                { isOpenModalRechazarCalculo &&
                                    <div id="modal-resultados-validacion">   
                                        <Modal titulo={modo_cap_doc === 2? 'MOTIVO DE RECHAZO':modo_cap_doc === 3? "COMPROBANTE DE PAGO":"" } isOpen={isOpenModalRechazarCalculo} closeModal={CerrarModalRechazo} Height={'auto'}  Width={'80vw'} >
                                            <div className="container-fluid">
                                                {
                                                    modo_cap_doc === 3  ?
                                                    <div className="row">   
                                                        <div className="col-12 m-0">
                                                            {modo_cap_doc === 3 && ((decCreditLimit*0.05) > balance) ?
                                                            <div className="alert alert-warning ">
                                                                {"Estimado usuario el saldo disponible de su línea de crédito se encuentra por debajo del 5%. para evitar inconvenientes y garantizar la continuidad de sus operaciones, le recomendamos realizar sus pagos a la brevedad posible."}            
                                                            </div>:
                                                            //CASO USUSARIO NO TIENE SALDO EN LA LINEA DE CREDITO.
                                                            modo_cap_doc === 3 && ((decCreditLimit) <= 0 || balance <= 0) ?        
                                                            <div className="alert alert-danger fs-5  ">
                                                                {"Estimado usuario le informamos que su línea de crédito ha alcanzado el límite establecido. Para continuar con su operación, le solicitamos amablemente adjuntar un comprobante de pago que permita regularizar su saldo."}            
                                                            </div>:<></>
                                                            }
                                                        </div>
                                                    </div>:<></>
                                                }
                                                
                                                 
                                                

                                                {balance < 0 ?
                                                <div className="row">   
                                                    <div className="col-12 m-0">
                                                        <div className="alert alert-danger ">
                                                            <label>
                                                                {balance >= 0 ?
                                                                    "":"HA EXCEDIDO SU LINEA DE CREDITO POR LA CANTIDAD DE: "+Formato_Moneda(balance)+"  EL CÁLCULO DE ALMACENAJE REQUIERE COMPROBANTE DE PAGO."
                                                                }
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>:<></>
                                                }       
                                               

                                                <div className="row">    
                                                    <div className="col-12 my-1">
                                                        <label   >{/*MOTIVO DE RECHAZO:*/}COMENTARIO: </label> 
                                                        <textarea name="txtcomment" id="txtcomment" className={`form-control ${validacomment}`} defaultValue={comment} onChange={(evt)=>handleMotivoRechazar(evt.target.value)} minLength={10} maxLength={150} />    
                                                    </div> 
                                                
                                                    <div className="col-12 my-2">
                                                        <label  htmlFor="pdffile">DOCUMENTO:</label> 
                                                        <input id="pdffile" type="file" className={`form-control form-control-sm ${validaarchivo}`} value={filepdf}  style={{display:"none"}} accept='application/pdf, image/jpeg' onChange={(evt)=>{handleFileChanges(evt)}} />
                                                            
                                                        <label htmlFor="pdffile" className={`form-control form-control-sm ${validaarchivo}`} > 
                                                            {/*<Iconos  cLass='bi flex-shrink-0 me-2' icono={"PDF"}  width={"35"} height={"35"} fill="#F00"/>*/}
                                                            {
                                                              pdfData !== ""?
                                                                <span className="text-success ">ARCHIVO CARGADO : <span className="fw-bold">{pdfname}</span> </span>
                                                                :<span className="text-danger fw-bold">SIN ARCHIVO CARGADO</span>
                                                            } 
                                                        </label>
                                                        <div className="col-12  p-0 m-0">
                                                            { msgfile && 
                                                                <p className="text-danger fw-bold">
                                                                    {msgfile}
                                                                </p>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-12 my-2">
                                                        <div className="col-12 my-1">
                                                            <label   >NOMBRE DEL ARCHIVO:</label>  
                                                            <input id="txtnombrearchivo" type="test" className={`form-control ${validanombrearchivo}`} value={pdfname} onChange={(evt)=>{HandleNombreArchivo(evt.target.value)} } />
                                                        </div> 
                                                    </div>
                                                    {modo_cap_doc === 3?
                                                    <div className="row">
                                                        <div className="alert alert-warning ">
                                                            <p className="my-0 fw-bold">
                                                                <i>EL PROCESO DE VALIDACIÓN PUEDE TARDAR 48HRS HÁBILES O BIEN PUEDE COMUNICARSE CON EL DEPARTAMENTO DE INGRESOS EN EL AREA DE FACTURACIÓN.</i>
                                                            </p>
                                                        </div>
                                                    </div>        
                                                    :<></>
                                                } 
                                                    <div className="col-12">
                                                        <div className="row  p-0">
                                                            <div>
                                                                {modo_cap_doc === 2?
                                                                    <button className="btn text-bg-danger fw-bold float-end mx-1" onClick={ConfirmarRechazarCalculo}>GUARDAR RECHAZO DE CÁLCULO</button>
                                                                    :modo_cap_doc === 3?
                                                                        <button className="btn text-bg-primary fw-bold float-end mx-1" onClick={ConfirmarRechazarCalculo}>CONFIRMAR Y ENVIAR COMPROBANTE DE PAGO</button>
                                                                        :<></>
                                                                }
                                                                <button className="btn text-bg-secondary text-white fw-bold float-end mx-1" onClick={CerrarModalRechazo}>CANCELAR</button>
                                                            </div>
                                                        </div>  
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal>
                                    </div>
                                }

                                 
                        </div>

                        {dtodias_almacenaje.length>0?
                        <div id="resultado_calculo">
                            <p className="h4 al" > DIAS LIBRES DE ALMACENAJE</p>
                            <hr /> 
                            <div className="row mx-1">
                                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 ">
                                    <div >
                                        <label className="float-start text-black" htmlFor="">{`VENCIO EL PLAZO DE DIAS LIBRES: ${plazodiaslibres}`}</label>
                                        <label className="float-end text-black mx-3" htmlFor="">{`${fechaalmacenaje}`}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-1">
                                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    <label className="text-black" htmlFor="">{`FOLIO DE CÁLCULO: `} 
                                        <span className="text-success">{folio}</span>
                                    </label>
                                </div>  
                                {/*<div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                   <label className="text-black"  htmlFor="">{`PARTE #: ${parte}`}</label> 
                                </div>  
                                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    <label className="text-black"  htmlFor="">{`TIPO: ${tipo}`}</label> 
                                </div>  */}
                                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    <label className="text-black"  htmlFor="">{`ESTADO: `}
                                        <span className={estado === "CAPTURADO"? "text-orange":estado === "ENVIADO"?"text-success":""} >{estado}</span>
                                    </label>
                                </div> 
                            </div> 

                            <div className="row mx-1">
                            { dtodias_almacenaje?       
                                    < >   
                                        <div  style={{ overflow:"scroll"}}>
                                        <GridComponent  
                                            dataSource={dtodias_almacenaje} 
                                            //ref={g => grid = g}
                                            dataStateChange={dtodias_almacenaje} 
                                            allowPaging={true} 
                                            allowResizing={true} 
                                            rowHeight={30} 
                                            height='auto' 
                                            allowFiltering={false}  
                                            allowSorting = {true} 
                                            pageSettings={{pageSize:15, pageCount:15,  pageSizes: true }} 
                                            //rowDataBound={rowDataBound} 
                                            >
                                            <ColumnsDirective >   
                                                {/*<ColumnDirective field={'intitemRow'}   Type={"ColumnType.Integer"} width='40' headerText="ITEM"   textAlign="left"/>*/}
                                                <ColumnDirective field={'description'}  template={cellDescripcion}   Type={"ColumnType.String"} width='100' headerText="REGLA"  textAlign="left"/>
                                                
                                                <ColumnDirective field={'serviceDate'}      Type={"ColumnType.String"} width='40' headerText="DESDE"  textAlign="left"/>
                                                <ColumnDirective field={'serviceEndDate'}      Type={"ColumnType.String"} width='40' headerText="HASTA"  textAlign="left"/>

                                                {/*esimo &&
                                                    <ColumnDirective field={'costBase'}      Type={"ColumnType.String"} width='40' headerText="CARGO POR IMO"  textAlign="left"/>*/
                                                }
                                                

                                                <ColumnDirective field={'costBase'}   template={cellMoneda}   Type={"ColumnType.Decimal"} width='40' headerText="TARIFA"  textAlign="left"/>
                                                <ColumnDirective field={'overcost'}   template={cellMoneda3}   Type={"ColumnType.Decimal"} width='40' headerText="SOBRECOSTO"  textAlign="left"/>
                                                <ColumnDirective field={'quantity'}      Type={"ColumnType.Integer"} width='40' headerText="DÍAS"   textAlign="left"/>
                                                <ColumnDirective field={'subtotal'}   template={cellMoneda2}   Type={"ColumnType.Decimal"} width='40' headerText="IMPORTE" textAlign="left"/>
                                                 
                                            </ColumnsDirective>  
                                            <Inject services={[Page,Filter,Sort,Resize ]} />
                                        </GridComponent><></>
                                        </div>
                                    </>
                                    :<></>

                                } 
                            <div className="row "> 
                            {   folio === "" ? 
                                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                    <div className="row m-0 p-0">
                                        <div className="col-12">
                                            <label className="text-black" htmlFor="">{`DÍAS ALMACENAJE: `} <span className="badge bg-success">{`${diasalamcenaje}`}</span></label>
                                        </div>
                                        <div className="alert alert-danger col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <label  title="Si no esta de acuerdo con el calculo puede rechazar el mismo mediante esta opción." className="form-check-label text-danger fs-6 " htmlFor="rechazarcalculo">
                                                <input className="form-check-input " type="checkbox" id="rechazarcalculo" disabled={folio===""? false:true} checked={esrechazarcalculo} onChange={hadleRechazarCalculo} />
                                                RECHAZAR CÁLCULO
                                            </label>  
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                                            <button  className="btn text-bg-primary  "
                                                disabled={folio === ""? false:true}  
                                                onClick={SolicitarComprobantePago}
                                                title="SI LO DESEA PUEDE ADJUNTAR UN COMPROBANTE DE PAGO JUNTO CON SU CALCULO DE ALMACENAJE." >
                                                AGREGAR COMPROBANTE DE PAGO 
                                            </button>
                                        </div>       
                                    </div>       
                                </div> :<></>
                            }
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-0 p-0">
                                <div className="row">
                                    <div className="px-5">
                                        <span className="text-black fw-bold float-start" htmlFor="">
                                            SUB-TOTAL: 
                                        </span>
                                        <span className="text-black fw-bold float-end" htmlFor="">
                                            {Formato_Moneda(subtotal)}{bandera()}
                                        </span>
                                    </div>
                                 

                                <div className="px-5">
                                    <span className="text-black fw-bold float-start" htmlFor="">
                                        IVA 16%:
                                    </span>
                                    <span className="text-black fw-bold float-end" htmlFor="">
                                        {Formato_Moneda(iva)}{bandera()}
                                    </span> 
                                </div>    

                                <div className="px-5">
                                    <span className="text-black fw-bold float-start" htmlFor="">
                                        TOTAL:
                                    </span>
                                    <span className="text-black fw-bold float-end" htmlFor="">
                                    {Formato_Moneda(total)}{bandera()}
                                    </span> 
                                </div>   
                                </div>    
                            </div>  
                            </div>  
                            <div className="row ">
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    <button id="btn_nuevo_calculo" className="btn text-bg-secondary fw-bold w-100 py-3 my-0" onClick={NuevoCalculo}>NUEVO CÁLCULO DE ALMACENAJE</button>
                                </div>    
                                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    {   folio === ""? 
                                        <button id="btn_enviar_calculo" className="btn text-bg-warning fw-bold w-100  py-3 my-0" onClick={Send_Calc} >ENVIAR CÁLCULO DE ALMACENAJE</button>
                                        :<div className="alert alert-success py-3 my-0"><span>Este cálculo se ha enviado con éxito.</span></div>
                                    }
                                </div>
                            </div>  
                        </div>
                        </div>:<></>
                        }
                    </TabPanel>                         
                    <TabPanel key={"panel_consultar"}>
                        <div className="container-fluid">
                            <div className="row py-1">
                                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 " >
                                    <label className="text-black col-12 " htmlFor="">{`CONTENEDOR: ${contenedor}`}</label>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 " >
                                    <button className="btn text-bg-primary" onClick={()=>{GetCalcSumarys(lngUniversalId)}}>ACTUALIZAR ALMACENAJES</button>
                                </div>
                            </div>
                            <div className="row">
                                { calcsumarys?       
                                    < >   
                                        <div  style={{ overflow:"scroll"}}>
                                            
                                        <GridComponent  
                                            dataSource={calcsumarys} 
                                            //ref={g => grid = g}
                                            dataStateChange={calcsumarys} 
                                            allowPaging={true} 
                                            allowResizing={true} 
                                            rowHeight={30} 
                                            height='auto' 
                                            allowFiltering={false}  
                                            allowSorting = {true} 
                                            pageSettings={{pageSize:15, pageCount:15,  pageSizes: true }} 
                                            //rowDataBound={rowDataBound} 
                                            >
                                            <ColumnsDirective > 
                                                <ColumnDirective field={'intStorageFeeId'}   template={ColumnDownload} width='50' headerText="DESCARGAR" textAlign="center"/>
                                                <ColumnDirective field={'intStorageFeeId'}   Type={"ColumnType.Integer"} width='40' headerText="ID CÁLCULO"   textAlign="left"/>
 
                                                <ColumnDirective field={'strFeeStartDate'}   Type={"ColumnType.String"} width='55' headerText="FECHA INICIO DEL CÁLCULO"  textAlign="left"/>
                                                <ColumnDirective field={'strFeeEndDate'}     Type={"ColumnType.String"} width='55' headerText="FECHA TERMINO DEL CÁLCULO"  textAlign="left"/>

                                                {/*<ColumnDirective field={'strFeeDate'}      Type={"ColumnType.String"} width='55' headerText="FECHA DE CÁLCULO"  textAlign="left"/>
                                                <ColumnDirective field={'strCreatedDate'}      Type={"ColumnType.Integer"} width='70' headerText="FECHA DE CREACIÓN"   textAlign="left"/>*/}
                                                
                                                <ColumnDirective field={'strFeeType'}      Type={"ColumnType.Integer"} width='70' headerText="TIPO DE CÁLCULO" textAlign="left"/>
                                                <ColumnDirective field={'decSubTotal'}      Type={"ColumnType.String"} width='50' headerText="SUB TOTAL"  textAlign="left"/>
                                                <ColumnDirective field={'decTaxes'}      Type={"ColumnType.String"} width='60' headerText="IMPUESTOS"  textAlign="left"/>
                                                <ColumnDirective field={'decTotal'}      Type={"ColumnType.String"} width='60' headerText="TOTAL"  textAlign="left"/>
                                                 
                                             
                                            </ColumnsDirective>  
                                            <Inject services={[Page,Filter,Sort,Resize ]} />
                                        </GridComponent>
                                        </div>
                                    </>
                                    :<></>
                                } 
                            </div>
                        </div>
                    </TabPanel>
            </Tabs>    
        </>
    )
}
 
export default Detalle_Calcular_Almacenaje;